// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationFeaturesText-cls1_-hn","cls2":"TranslationFeaturesText-cls2_Tlg TranslationFeaturesText-cls1_-hn"};